import axios, { AxiosResponse } from "axios";
import { notify } from "../utils/Notify";
import { NotifyType } from "../utils/NotifyType";
import { ApiUrl } from "../utils/app-config";
import { errorLogging } from "../utils/errorLogging";
import { apexToken } from "../services/apexToken";
import { getConfig } from "./configService";

export const apexApiService = () => {
    let APEX_BASE_URL = "";
    try {
        const cfg = getConfig();
        APEX_BASE_URL = cfg.REACT_APP_API_APEX_BASE_URL || APEX_BASE_URL;
    } catch (e) {
        // config not loaded yet — values stay empty
        console.warn('Config not loaded: APEX base URL is empty');
    }
    const { handleHttpError } = errorLogging();
    const { message } = notify();
    const { GetApexToken } = apexToken();

    const CreateSfaUser = async (request:any): Promise<any | null> => {
        let response: AxiosResponse<any> | void;
        const apexToen = await GetApexToken(`${ApiUrl.CreateSfaUser}`);
        const headers = {
            'Content-Type': 'application/json',
            'authorization' : `Bearer ${apexToen?.jwtToken}`
        }
        response = await axios.post(`${APEX_BASE_URL}${ApiUrl.CreateSfaUser}?accountid=${apexToen?.accountId}&nonce=${apexToen?.nonce}&ts=${apexToen?.timestamp}`,request,  {
            headers: headers
        }).catch(err => { handleHttpError(err, false) });
        if (response && response.status === 200) {
            return response.data;
        } else {
            message(NotifyType.Info, "Error in apex create sfa user")
            return response;
        }
    }  
    
    const CreateEservicesUser = async (request:any): Promise<any | null> => {
        let response: AxiosResponse<any> | void;
        const apexToen = await GetApexToken(`${ApiUrl.CreateEservicesUser}`);        
        const headers = {
            'Content-Type': 'application/json',
            'authorization' : `Bearer ${apexToen?.jwtToken}`
        }
        response = await axios.post(`${APEX_BASE_URL}${ApiUrl.CreateEservicesUser}?accountid=${apexToen?.accountId}&nonce=${apexToen?.nonce}&ts=${apexToen?.timestamp}`,request,  {
            headers: headers
        }).catch(err => { handleHttpError(err, false) });
        if (response && response.status === 200) {
            return response.data && typeof response.data === "object"
                ? response.data
                : null;
        } else {
            message(NotifyType.Info, "Error in apex create e-services user")
            return response;
        }
    }

    const ForeignerLoginUser = async (request: any): Promise<any | null> => {
        let response: AxiosResponse<any> | void;
        const apexToen = await GetApexToken(`${ApiUrl.CreateForeignerUser}`);
        const headers = {
            'Content-Type': 'application/json',
            'authorization' : `Bearer ${apexToen?.jwtToken}`
        }
        response = await axios.post(`${APEX_BASE_URL}${ApiUrl.CreateForeignerUser}?accountid=${apexToen?.accountId}&nonce=${apexToen?.nonce}&ts=${apexToen?.timestamp}`,request,  {
            headers: headers
        }).catch(err => { handleHttpError(err, false) });
        if (response && response.status === 200) {
            return response.data;
        } else {
            return null;
        }
      }

      const ForgetPasswordApi = async (request: any): Promise<any | null> => {
        let response: AxiosResponse<any> | void;
        const apexToen = await GetApexToken(`${ApiUrl.CreateForgetPassword}`);
        const headers = {
            'Content-Type': 'application/json',
            'authorization' : `Bearer ${apexToen?.jwtToken}`
        }
        response = await axios.post(`${APEX_BASE_URL}${ApiUrl.CreateForgetPassword}?accountid=${apexToen?.accountId}&nonce=${apexToen?.nonce}&ts=${apexToen?.timestamp}`,request,  {
            headers: headers
        }).catch(err => { handleHttpError(err, false) });
        if (response && response.status === 200) {
            return response.data;
        } else {
            return null;
        }
      }

  return {
    CreateSfaUser,
    CreateEservicesUser,
    ForeignerLoginUser,
    ForgetPasswordApi
  }
}